import { type FormValuesEvents, useFormStore } from "@/widgets/classic-form/form";
import {
    type EventExactnessConfig,
    useEventFieldsWithExactnessDisabled,
} from "../shared/useEventFieldsWithExactnessDisabled";

export const eventsAreExact = (events: FormValuesEvents, config: EventExactnessConfig) =>
    Object.entries(events).every(([eventKey, event]) => {
        if (!event.instances.length) return true;
        const yearDisabled = config.yearDisabled.has(eventKey);
        const placeDisabled = config.placeDisabled.has(eventKey);

        return event.instances.every((instance) => {
            if (instance.isRangeMode) {
                return placeDisabled || instance.locationExactness !== null;
            }

            const dateIsExact = yearDisabled || instance.dateProximity?.year !== null;
            // Any non-null locationExactness counts as "exact" — including the
            // computed level-based default (e.g. "exact to State"). Only null (Broad)
            // is considered not-exact. (EGE-8089 AC 6.1)
            const locationIsExact = placeDisabled || instance.locationExactness !== null;
            return dateIsExact && locationIsExact;
        });
    });

export const useEventExactness = () => {
    const config = useEventFieldsWithExactnessDisabled();
    const isExact = useFormStore((data) => eventsAreExact(data.values.events, config));
    return isExact;
};
